module.exports = __webpack_public_path__ + "static/media/paper-bg.fa7f136d.jpg";